import apiContact from '@/api/contact'

const state = {
	data: {}
}

const getters = {
	data(state) {
		return state.data
	}
}

const mutations = {
	setData(state, data) {
		state.data = data
	}
}

const actions = {
	fetchData({ commit }) {
		apiContact.getData(data => commit('setData', data))
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
